module.exports = __webpack_public_path__ + "static/productDel-6eb31cbbe4ce7e6deffe31706ce85507.png";